module.exports = __webpack_public_path__ + "images/mobile/img-error-500-3aaa86bf8213495b46d45e9b97aa87f9.png";